// Campus photo for /colleges/california-state-polytechnic-university-pomona: CC BY-SA 3.0, by Victorrocha, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACal_Poly_Library_Entrance.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/california-state-polytechnic-university-pomona/; credited under the photo.
const photo = {
    "slug": "california-state-polytechnic-university-pomona",
    "alt": "The main entrance of the University Library at Cal Poly Pomona in Pomona, California",
    "src": "/colleges/california-state-polytechnic-university-pomona/campus-1600.webp",
    "srcSmall": "/colleges/california-state-polytechnic-university-pomona/campus-800.webp",
    "srcMid": "/colleges/california-state-polytechnic-university-pomona/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/california-state-polytechnic-university-pomona/og.jpg",
    "title": "Cal Poly Library Entrance",
    "author": "Victorrocha",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACal_Poly_Library_Entrance.jpg",
    "read": "2026-09-30"
};

export default photo;
